import { AUDIENCE_CARD_IDS } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { Section } from "../layout/Section";

import styles from "./Audience.module.css";

export function Audience() {
  const { copy } = useLocale();

  return (
    <Section
      eyebrow={copy.audience.eyebrow}
      title={copy.audience.title}
      className={styles.section}
    >
      <div className={styles.grid}>
        {AUDIENCE_CARD_IDS.map((id) => {
          const card = copy.audience.cards[id];
          return (
            <article key={id} className={styles.card}>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardText}>{card.description}</p>
            </article>
          );
        })}
      </div>
    </Section>
  );
}
